const module = { name: 'Fandango/adobeLaunch', exports: {} }; const exports = module.exports;



const EventTypes = {
    AUDIENCE_SCORE: 'audience score clicks',
    AUDIENCE_SCORE_GOT_IT: 'audience score modal got it clicks',
    AUDIENCE_SCORE_LEARN_MORE: 'audience score modal learn more clicks',
    AUDIENCE_SCORE_MODAL: 'audience score modal impressions',
    BUY_TICKETS_BELOW_CLICK: 'BuyTicketsBelowClick',
    CHANGE_LOCATION_CLICKS: 'change location clicks',
    CITY_STATE_ENTERED: 'city state entered',
    CONCESSION_AMENITY_CLICK: 'preorderFoodDrinks',
    DATE_SELECTED: 'date selected',
    DATE_SHOWTIME: 'date showtime presence',
    DATE_SHOWTIME_FORMAT: 'date showtime format presence',
    FAN_ALERT_SIGNUP: 'fan alert sign up',
    FAN_REVIEW_FAIL: 'fan review error',
    FAN_REVIEW_SUCCESS: 'fan review success',
    FANCLUB_ANNUAL_CLICK: 'FanclubAnnualClick',
    FANCLUB_CONTINUE_CLICK: 'LandingContinueClick',
    FANCLUB_MONTHLY_CLICK: 'FanclubMonthlyClick',
    FAQ_MORE: 'faq more click',
    FAQ_YES_NO: 'faq yes or no click',
    FAVORITE_MOVIE_CLICKS: 'add movie to favorites clicks',
    FAVORITE_THEATER_CLICKS: 'favorite cinema clicks',
    FILTER_ALL_THEATERS_CLICKS: 'filter all cinemas clicks',
    FILTER_OPEN_THEATERS_CLICKS: 'filter open clicks',
    FORMAT_CLICKS: 'format clicks',
    FORMAT_SELECTED: 'format selected',
    GENERIC_CLICK: 'generic click',
    GLOBAL_OFFER_CLICK: 'navPromoLinkClick',
    GLOBAL_OFFER_ARROW_CLICK: 'navPromoArrowClick',
    IN_THEATERS_CAROUSEL_CTA_CLICK: 'InTheatersBuyTicketsClicked',
    IN_THEATERS_CAROUSEL_POSTER_CLICK: 'InTheatersPosterClicked',
    INTERNAL_SEARCH_CLICK: 'internal search clicks',
    INTERNAL_SEARCH_RESULT_CLICK: 'internal search result clicks',
    LEARN_MORE: 'learn more clicks',
    LOCATION_ERROR: 'use current location error',
    MICROSITE_BOOK_GROUP_CLICK: 'bookYourGroupClick',
    MICROSITE_CARD_1_CLICK: 'card1Click',
    MICROSITE_CARD_2_CLICK: 'card2Click',
    MICROSITE_CONTENT_CLICK: 'contentClick',
    MICROSITE_FIND_TICKETS_CLICK: 'findTicketsClick',
    MICROSITE_GIFT_TICKET_CLICK: 'giftATicketClick',
    MICROSITE_MAIN_BTN_CLICK: 'mainBtnClick',
    MICROSITE_SECONDARY_BTN_CLICK: 'secondaryBtnClick',
    MICROSITE_TRAILER_CLICK: 'trailerClick',
    MODAL: 'modal',
    MOP_PAGE_STATE: 'mop page state',
    MORE_MOVIES_TV_CLICKS: 'more movies & tv shows clicks',
    MOVIE_POSTER_CLICKS: 'movie poster clicks',
    PAGE_VIEW: 'pageview',
    PERFORMER_CLICK: 'performer click',
    PHOTO_CLICKS: 'photo clicks',
    SEARCH_RESULTS: 'search results',
    SEARCH_ZIP_CODE_CLICKED: 'search zip code clicked',
    THEATER_MODULE_THEATER_CLICKED: 'theater module theater clicked',
    TOMATOMETER: 'tomatometer clicks',
    USE_CURRENT_LOCATION: 'use current location click',
    VAS_ROLLOVER: 'verified rollover',
    VIDEO: 'video',
    VIDEO_AD_COMPLETE: 'videoAdComplete',
    VIDEO_AD_RESUME: 'videoAdResume',
    VIDEO_AD_START: 'videoAdStart',
    VIDEO_AD_STOP: 'videoAdStop',
    VIDEO_START: 'video start clicks',
    WATCH_ON_DEMAND_CLICKS: 'watch on demand clicks',
    WATCH_VIDEOS_CLICKS: 'watch videos clicks',
    ZIP_CODE_ENTERED: 'zip code entered',
    ZIP_CODE_DROPDOWN_LOAD: 'zip code dropdown load',
}
function track(data) {
    if (!data) {
        return;
    }
    let event;
    if (typeof data === 'string') {
        event = {
            event: data
        };
    }
    else if (typeof data === 'object') {
        event = data;
    }
    else {
        return;
    }
    if (!Array.isArray(window.dataLayer)) {
        return;
    }
    window.dataLayer.push(event);
}
module.exports = {
    EventTypes,
    track,
};
export default module.exports;